module.exports = __webpack_public_path__ + "static/media/2.7ae7ae89.svg";